import { redirect, type LoaderFunctionArgs } from 'react-router';
import { env } from 'shared/config';
import * as v from 'valibot';

import { FlowSchema } from '@/flows/lib/api';
import { LiveOffersSimplifiedFlow } from '@/flows/screens/live-offers/-shared/flows/simplified';

export const liveOffersLoader = async (args: LoaderFunctionArgs) => {
  if (env === 'release') {
    throw redirect('/404');
  }

  const search = new URL(args.request.url).searchParams;
  const nodeId = search.get('node') || undefined;
  const source = search.get('source') || 'DIRECT';

  const flow = v.parse(FlowSchema, LiveOffersSimplifiedFlow);

  return {
    flow,
    nodeId,
    initialData: {
      web_rec_id: args.params.web_rec_id!,
      source,
    },
  };
};

export type LiveOffersLoaderData = Awaited<ReturnType<typeof liveOffersLoader>>;
